import { Phone, Facebook, Instagram, Twitter, Youtube } from "lucide-react";
import { NAV_LINKS, PHONE, PHONE_TEL } from "../data";

const SOCIALS = [
  { icon: Facebook, label: "Facebook", testid: "footer-social-facebook" },
  { icon: Instagram, label: "Instagram", testid: "footer-social-instagram" },
  { icon: Twitter, label: "Twitter", testid: "footer-social-twitter" },
  { icon: Youtube, label: "YouTube", testid: "footer-social-youtube" },
];

export const Footer = () => (
  <footer data-testid="footer-section" className="border-t border-gold/20 bg-navy pb-24 pt-14 md:pb-14">
    <div className="section-wrap">
      <div className="flex flex-col items-center text-center">
        <p className="font-serif text-2xl font-bold tracking-wide text-cream sm:text-3xl">
          Kasdol <span className="text-gold">Hotel</span>
        </p>
        <p className="mt-2 text-sm text-cream/60">Marriage Hall • Hotel Rooms • Restaurant</p>

        <nav data-testid="footer-nav-links" aria-label="Footer navigation" className="mt-8 flex flex-wrap justify-center gap-x-6 gap-y-2">
          {NAV_LINKS.map((l) => (
            <a
              key={l.href}
              href={l.href}
              data-testid={`footer-${l.testid}`}
              className="text-sm text-cream/75 transition-colors hover:text-gold"
            >
              {l.label}
            </a>
          ))}
        </nav>

        <a
          href={PHONE_TEL}
          data-testid="footer-phone-link"
          className="mt-7 inline-flex items-center gap-2 font-serif text-xl font-semibold text-gold transition-colors hover:text-cream"
        >
          <Phone className="h-5 w-5" /> {PHONE}
        </a>

        <div className="mt-7 flex gap-3">
          {SOCIALS.map((s) => (
            <a
              key={s.label}
              href="#home"
              data-testid={s.testid}
              aria-label={`Kasdol Hotel on ${s.label}`}
              className="inline-flex h-10 w-10 items-center justify-center rounded-full border border-cream/20 text-cream/70 transition-colors hover:border-gold hover:text-gold"
            >
              <s.icon className="h-4 w-4" />
            </a>
          ))}
        </div>
      </div>

      <div className="mt-10 border-t border-cream/10 pt-6 text-center">
        <p data-testid="footer-copyright" className="text-xs text-cream/50">
          © 2026 Kasdol Hotel. All Rights Reserved.
        </p>
      </div>
    </div>
  </footer>
);
